import { useQuery } from "@tanstack/react-query";
import { getCart } from "src/api/cart";
export const getCurrentCartQuery = (param)=>{
    let { enabled , params  } = param;
    return useQuery([
        "currentCart",
        params
    ], ()=>getCart(params), {
        enabled
    });
};
